import React from 'react';
import { Controller } from 'react-hook-form';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const FormInputSelect = ({
  name,
  control,
  label,
  options,
  onChange,
  inputHeight = 38,
  required = false,
  error = false,
  helperText = '',
  errorStyle = { border: false },
  ...props
}) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange: fieldOnChange, value } }) => (
        <FormControl 
          fullWidth 
          size="small"
          required={required}
          error={error}
        >
          <InputLabel>{label}</InputLabel>
          <Select
            value={value}
            label={label}
            onChange={(e) => {
              fieldOnChange(e);
              if (onChange) {
                onChange(e);
              }
            }}
            sx={{
              height: inputHeight,
              '& .MuiSelect-select': {
                padding: '8px 14px',
              },
              ...(error && errorStyle.border && {
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'error.main',
                },
              }),
            }}
            {...props}
          >
            {options.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    />
  );
};

export default FormInputSelect;